import { vec } from "excalibur";
import { Config } from "./config";
import Dialog from "./ui/dialog";

export default class BeeClassManager {
  constructor(items, char1, char2, endScene) {
    this.items = items;
    this.action = 0;
    this.moveFunction = char1.moveFunction;
    this.char1 = char1;
    this.char1.cutScene = true;
    this.endScene = endScene;
  }
  move(action) {
    console.log("cutscene: inside move: ", this.items);
    switch (action.direction) {
      case "exclaim":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphics.use("exclaim");
          })
          .delay(1000)
          .callMethod(() => {
            this.char1.graphics.use("downIdle");
          })
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "left":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphics.use("leftWalk");
          })
          .moveBy(vec(-action.content, 0), 20)
          .callMethod(() => {
            this.char1.graphics.use("leftIdle");
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "right":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphics.use("rightWalk");
          })
          .moveBy(vec(action.content, 0), 20)
          .callMethod(() => {
            this.char1.graphics.use("rightIdle");
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "up":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphics.use("upWalk");
          })
          .moveBy(vec(0, -action.content), 20)
          .callMethod(() => {
            this.char1.graphics.use("idleUp");
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      case "down":
        this.char1.actions
          .callMethod(() => {
            this.char1.graphics.use("downWalk");
          })
          .moveBy(vec(0, action.content), 20)
          .callMethod(() => {
            this.char1.graphics.use("idleDown");
          })
          .delay(500)
          .callMethod(() => {
            this.nextAction();
          });
        break;
      default:
        break;
    }
  }
  enterPress() {
    if (this.dialog) {
      this.dialog.enterPress();
    }
  }
  getItems() {
    return this.items;
  }
  getAction() {
    return this.action;
  }
  nextAction() {
    console.log("cutscene: inside nextAction: ", this.items);
    if (this.action == this.items.length - 1) {
      if (this.loop) {
        this.action = 0;
      } else {
        this.endScene();
        return;
      }
      this.startScene();
    } else {
      this.action++;
      this.startScene();
    }
  }
  startScene() {
    console.log(
      "cutscene:  started: ",
      this.items,
      " char1: ",
      this.char1,
      " first action: ",
      this.items[this.action]
    );
    if (this.items[this.action].action == "move") {
      console.log("cutscene: move");
      this.move(this.items[this.action]);
    } else if (this.items[this.action].action == "dialog") {
      this.dialog = new Dialog(
        this.items[this.action].content,
        () => {
          console.log("dialog ended");
          this.nextAction();
        },
        "professor",
        "bottom"
      );
    }
  }
}
